import * as t from "io-ts";

export const codec = t.union([
    t.literal("energy_certificate"),
    t.literal("floorplan"),
]);

export type T = t.TypeOf<typeof codec>;
